<mat-card>
  <mat-card-header>
    <h1 mat-card-title>{{ 'reset_Password_tr' | translate }}</h1>
  </mat-card-header>

  <mat-card-content>
    <div>
      {{ 'reset_password_note_tr' | translate }}
    </div>

    @if (invalid) {
      <div>
        {{ 'Invalid_Reset_Token_tr' | translate }}
      </div>
    }

    <form (keydown.enter)="$event.stopPropagation()" [formGroup]="form">
      <mat-form-field>
        <mat-label>{{ 'Email_tr' | translate }}</mat-label>
        <input autotrim email formControlName="email" lowerCase matInput autocomplete="username" />
        <mat-error>{{ 'Required_field_tr' | translate }}</mat-error>
      </mat-form-field>

      <form-actions>
        <button type="submit" (click)="resetRequest()" [disabled]="form.invalid || !form.dirty" color="primary" mat-raised-button>
          <mat-icon>exit_to_app</mat-icon>
          {{ 'reset_Password_tr' | translate }}
        </button>
      </form-actions>

      @if (showV2Fallback) {
        <app-recaptcha-v2-fallback (solved)="onV2Solved($event)" />
      }
    </form>
  </mat-card-content>

  <mat-card-actions>
    <a [routerLink]="['/login']" [queryParams]="backToLoginQueryParams">
      {{ 'back_to_login_page_tr' | translate }}
    </a>
  </mat-card-actions>
</mat-card>
